<template>
    <div class="loader" v-if="visible">
      <!-- You can customize your loader style here -->
      <div class="spinner"></div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      }
    }
  }
  </script>
  
  <style scoped>
  .loader {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999;
  }
  .spinner {
    border: 16px solid #f3f3f3;
    border-top: 16px solid #205A36;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  </style>